###
    Payment widget

    Robokassa
###
class INTENT.widgets.PaymentRobokassa

  @ATTR_NAME: "data-widget-payment"

  @ATTR_TOTAL_SUM: "#{@ATTR_NAME}-total-sum-handler"

  @ATTR_SUBMIT_BTN: "#{@ATTR_NAME}-submit"

  @CLASS_ERROR: "error-input-field"

  @NDS_PERCENT: 1.18

  constructor: (@el) ->
    @s = @.constructor

    @el.on 'submit', @submit_event
    @inputs = @el.find 'input'

    @total_sum_handler = @el.find "[#{@s.ATTR_TOTAL_SUM}]"

    @salt_input = @inputs.filter "[name='SignatureValue']"
    @invoice_input = @inputs.filter "[name='InvId']"
    @value_input = @inputs.filter "[name='shp_origin_sum']"
    @sum_input = @inputs.filter "[name='OutSum']"

    @amountGroup = @value_input.parents('.form-group')

    @min = parseFloat @el.attr('data-min')
    @max = parseFloat @el.attr('data-max')

    @btn = @el.find "[#{@s.ATTR_SUBMIT_BTN}]"

    @reset_runtime_filed()
    @calc_nds_sum()
    @value_input.on "change, keyup", (e) =>
      self = $ e.currentTarget
      value = parseFloat self.val()
      value = 0 if isNaN value

      unless isNaN(@min)
        if value < @min
          @amount_error __('payment.min', {':value': @min})
        else
          @amount_error_clear()

      unless isNaN(@max)
        if value > @max
          @amount_error __('payment.max', {':value': @max})
        else
          @amount_error_clear()

      @reset_runtime_filed()
      @calc_nds_sum()

  reset_runtime_filed: () =>
    @salt_input.attr 'value', ''
    @invoice_input.attr 'value', ''

  calc_nds_sum: () =>
    val = parseFloat @value_input.val()
    if isNaN val then val = 0
    val = val * @s.NDS_PERCENT
    val = val.toFixed 2
    @sum_input.attr 'value', val
    @total_sum_handler.html val

  amount_error: (text) =>
    @btn_status 'disabled'
    @amountGroup.addClass 'has-error'
    @amountGroup.find('.error').html(text)

  amount_error_clear: =>
    @btn_status 'enabled'
    @amountGroup.removeClass 'has-error'
    @amountGroup.find('.error').html('')

  btn_status: (status = 'disabled') =>
    if status == 'disabled'
      @btn.attr 'disabled', 'disabled'
    else if status == 'enabled'
      @btn.removeAttr 'disabled'

  submit_event: () =>
    @calc_nds_sum()
    @value_input.removeClass @s.CLASS_ERROR

    unless parseFloat @value_input.val()
      @value_input.addClass @s.CLASS_ERROR
      return false

    if @salt_input.val()
      return true

    params = {
      url: '/processing/create_rub_payment',
      type: 'POST',
      data: @el.serialize()
    }

    $.ajax(params).done (xhr) =>
      if xhr.error
        @amount_error __('payment.' + xhr.type, {':value': xhr.limit})
      else
        @amount_error_clear()
        @salt_input.attr 'value', xhr.salt
        @invoice_input.attr 'value', xhr.invoice

        @el.submit()

    return false


###
    Stripe
###
class INTENT.widgets.PaymentStripe

  @ATTR_NAME: "data-widget-stripe"

  @ATTR_SUBMIT_BTN: "#{@ATTR_NAME}-btn"
  @ATTR_SUBMIT_CANCEL_BTN: "#{@ATTR_NAME}-cancel-btn"

  @CLASS_ERROR: "error-input-field"

  @COMMISSION: 1.03

  constructor: (@el) ->
    @s = @.constructor

    @process_finish = false

    @inputs = @el.find 'input'
    @value_input = @inputs.filter "[name='origin']"
    @sum_input = @inputs.filter "[name='amount']"

    @btn = @el.find "[#{@s.ATTR_SUBMIT_BTN}]"
    @btn_cancel = @el.find "[#{@s.ATTR_SUBMIT_CANCEL_BTN}]"

    @charge_in_process = @el.find ".charge-in-process"

    @amountGroup = @value_input.parents('.form-group')

    @min = parseFloat @el.attr('data-min')
    @max = parseFloat @el.attr('data-max')

    @el.on 'submit', @submit_event

    @value_input.on "change, keyup", (e) =>
      self = $ e.currentTarget
      value = parseFloat self.val()
      value = 0 if isNaN value

      unless isNaN(@min)
        if value < @min
          @amount_error __('payment.min', {':value': @min})
        else
          @amount_error_clear()

      unless isNaN(@max)
        if value > @max
          @amount_error __('payment.max', {':value': @max})
        else
          @amount_error_clear()
      @calc_commission_sum()

    @handler = StripeCheckout.configure {
      key: stripe_key,
      image: '/img/logo/stripe.png',
      token: @process_token
    }

  amount_error: (text) =>
    @btn_status 'disabled', false, false if @process_finish == false
    @amountGroup.addClass 'has-error'
    @amountGroup.find('.error').html(text)

  amount_error_clear: =>
    @btn_status 'enabled', false, false if @process_finish == false
    @amountGroup.removeClass 'has-error'
    @amountGroup.find('.error').html('')

  close_modal: =>
    $('#payment-modal').modal('hide')

  get_origin: () =>
    parseFloat @value_input.val()

  get_total_amount: () =>
    parseFloat @sum_input.val()

  make_param: (key, value) =>
    input = document.createElement 'input'
    input.type = "hidden"
    input.name = key
    input.value = value
    return input

  calc_commission_sum: () =>
    val = parseFloat @value_input.val()
    if isNaN val then val = 0
    val = val * @s.COMMISSION
    val = if parseInt(val) == val then val else val.toFixed 2
    @sum_input.attr 'value', val

  process_token: (token) =>
    @process_finish = true
    @btn_cancel.html __('stripe.wait')
    @btn_cancel.attr 'disabled', 'disabled'

    @charge_in_process.removeClass 'hidden'

    params = {
      token: token.id,
      email: token.email,
      amount: @get_total_amount(),
      origin: @get_origin(),
      invoiceId: @handler_xhr.invoice,
      advertiserId: @handler_xhr.advertiser,
      currency: @handler_xhr.currency.toLowerCase(),
    }

    $.redirect '/payment/success', params, 'POST'

  btn_status: (status = 'disabled', loader = true, withInput = true) =>
    if status == 'disabled'
      @btn_text_buffer = @btn.html()
      @value_input.attr 'readonly', 'readonly' if withInput == true
      @btn.attr 'disabled', 'disabled'
      @btn.html """ <i class="fa fa-circle-o-notch fa-spin"></i> """ if loader == true
    else if status == 'enabled'
      @btn.removeAttr 'disabled'
      @value_input.removeAttr 'readonly' if withInput == true
      @btn.html(@btn_text_buffer) if @btn_text_buffer != undefined and loader == true

  submit_event: () =>
    @value_input.removeClass @s.CLASS_ERROR

    @btn_status 'disabled'
    unless @get_total_amount()
      @value_input.addClass @s.CLASS_ERROR
      return false

    params = {
      url: '/processing/create_stripe_payment',
      type: 'POST',
      data: @el.serialize()
    }

    $.ajax(params).done (xhr) =>
      if xhr.error
        @amount_error __('payment.' + xhr.type, {':value': xhr.limit})
      else
        @handler_xhr = xhr
        @handler.open {
          name: 'Getintent USA Inc',
          description: 'GetIntent DSP Invoice #' + @handler_xhr.invoice,
          amount: @get_total_amount() * 100,
          currency: @handler_xhr.currency.toLowerCase(),
          allowRememberMe: false,
          closed: =>
            @btn_status 'enabled' if @process_finish == false
        }

    return false
